module.exports = __webpack_public_path__ + "img/softwareOpen2.28a90a1b.png";